import React from 'react'
import Accordion from '../../../../Accordion'
import PreFlightsNumber from '../../../../PreFlightsNumber'

const data = [
  {
    title: "Uçuşyň öň ýanyndaky barlag",
    columns: [
      "Raýat howa gämileriniň ýolagçylarynyň, şol sanda ýerli we halkara howa gatnawlarynda üstaşyr gatnaýan ýolagçylaryň goşlaryny, el goşlaryny we özlerini barlagdan geçirmeklik uçuşlaryň howpsuzlygyny üpjün etmek, ýolagçylaryň we ekipažyň agzalarynyň janyny we saglygyny goramak, uçary basyp almak we alyp gaçmak howpunyň we raýat awiasiýasynyň işine bikanun hereketler arkaly zyýan ýetirmekligiň öňüni almak, şeýle hem partlaýjy, zäherli, ýangyn howply, radioaktiw serişdeleriň, ýaraglaryň, ok-därileriň we ýolagçylara gadagan edilen ýükleriň we maddalaryň sanawyndaky beýleki zatlaryň bikanun daşalmagynyň öňüni almak (8973-nji resminama, 10-njy neşir, 2017-nji ýyl) Awiasiýa howpsuzlygy boýunça gollanma) maksady bilen amala aşyrylýar.",
      
      "Aşgabat halkara howa menziliniň girelgesinde ýolagçylaryň howpsuzlygyny üpjün etmek üçin howa menziline gelýänleriň ählisi deslapky barlagdan geçirilýär, bu barlag metal detektorlardan geçmegi, zerur zatlary barlamagy we raýatlaryň özlerini barlmaklygy öz içine alýar. Bu görülýän çäreler howa menziliň binasynda we uçarlarda howpsuzlygy üpjün etmäge gönükdirilendir.",
      
      "Aeroportda barlaglar ýörite tehniki gözleg gurallary we wideo gözegçilik ulgamlary bilen enjamlaşdyrylan ýörite otaglarda (barlag nokatlarynda), şeýle hem raýatlaryň özlerini (aýratynlykda) barlamaga niýetlenen otaglaryda geçirilýär.",
      
      "Ýolagçynyň ýany bilen alyp barýan goşlaryny barlamak şol ýolagçynyň hut özüniň gatnaşmagynda geçirilýär. Goş barlaglary ýolagçylaryň gatnaşmagynda-da we olarsyz hem geçirilip bilner.",
      
      "Öz ýany bilen alyp barýan goşlarynyň uçuşdan öň gözden geçirilmegine ýolagçynyň garşylyk görkezen halatynda Türkmenistanyň Howa gatnawlary kodeksiniň 72-nji maddasynyň 2-nji bendine laýyklykda ýolagçyny howa gämisinde äkitmek baradaky şertnama ýatyrylýar.",
      
      "Ýolagçynyň özüniň we onuň öz ýany bilen alyp barýan goşlarynyň uçuşdan öň barlagdan geçirilen wagtynda, ýolagçynyň peteginde (petek elektron görnüşde satyn alynmadyk halatynda) we (ýa-da) uçara münüş talonynda barlag geçirilendigi barada bellik goýulýar we ýolagça uçuşa garaşylýan zolaga geçmäge rugsat berilýär.",
      
      "Içerki gatnawlaryň ýolagçylaryny we olaryň el goşlaryny barlamak petekler hasaba alnandan soň amala aşyrylýar, halkara gatnawlaryň ýolagçylaryny barlamak – olar gümrük we serhet gullugynyň barlagyndan geçeninden soňra amala aşyrylýar.",
      
      "Pasport we gümrük barlagy zolagynda surata almak - wideo şekile düşürmek doly gadagan edilýändigini ýadyňyzdan çykarmaň."
    ]
  },
  {
    title: "Barlagdan geçmek üçin maslahatlar",
    columns: [
      "Uçara münüş talonyňyzy we şahsyýetiňizi tassyklaýan resminamaňyzy görkezmäge taýyn boluň.",
      
      "Üstki eşikleriňizi, kellä geýilýän geýimleriňizi, guşaklaryňyzy, sagatlaryňyzy we beýleki metal zatlaryňyzy aýyryň we plastik sebetlere ýerleşdiriň. Aýakgaplaryňyzy çykarmak hem soralyp bilner.",
      
      "Jübi telefonlaryňyzy, çilim otlaýjyňyzy, çilimleriňizi, teňňeleriňizi, açarlaryňyzy we beýleki metal zatlaryňyzy el goşlaryňyz salynýan torbaňyza ýerleşdiriň ýa-da plastik sebete salyň, elektron ýa-da elektrik enjamlaryňyzy aýratyn goýuň (mysal üçin şahsy kompýuterler, planşetler we ş.m.).",
      
      "El goşlaryňyzy barlag lentasynyň üstünde keseligine goýuň. El goşlaryňyzy konweýeriň erňeginde goýmaň - lenta herekete girizilende ters ugra hereket edip biler we el goşlaryňyzyň ýere gaçmagy mümkin.",
      
      "Elektrokardiostimulýator ulanýan ýolagçylar tehniki we ýörite serişdeleriň täsirine düşmän el üsti bilen barlamak arkaly gözegçilikden geçýärler. Elektrokardiostimulýator ulanýan ýolagçy ýol resminamalary barlanýan wagty ýa-da gözden geçirilişden öň howa gatnawlaryndaky howpsuzlyk gözegçisine özünde şeýle çäklendirmeleriň bardygyny habar bermäge borçludyr.",
      
      "Ýolagçylar howa menziliň barlag geçirýän işgärleriniň ähli talaplaryny berjaý etmäge borçludyr."
    ]
  },
  {

    title: "Ýolagçylaryň el goşlarynda hem-de ýüklerinde howa gämisiniň içinde öz ýany bilen alyp gidýän howply ýüklerine degişli düzgünnama",
    columns: [
      "ÝÜKDE WE EL GOŞGLARYNDA ÝANYŇ BILEN ALYP GITMEK GADAGAN EDILÝÄN ZATLAR:",
      "Маgnit materiallar",
      "Güýçli täsir ediji we psihiki ýagdaýyň bozulmagyna getiriji enjamlar",
      "Radioaktiw serişdeler",
      "Zäherleýji we awuly serişdeler, ýokanç materially gaplar, simap, antifriz, tormoz suwuklygy we ş.m.",
      "Gysylan we suwuklandyrylan gazlar: propan we ş.m., özüňi goramak üçin gazly ballonjyklar,zažigalkalar (absorlinmedik suwuk ýangyçsyz uly bolmadyk bir zažigalkadan başga, ýanyňdaky suwuklandyrylan gazdan başga) we ş. m.",
      "Aňsat ot alýan serişdeler: аseton, benzin, otlyçöpler ( ýanyňdaky howpsuz otlyçöpleriň uly bolmadyk bir gabyndan başga)  boýagly gapjagazlar we ş.m.",
      "Aňsat ot alýan gaty serişdeler: öz-özünden ot alýan ýa-da suw syçranda bada-bat ot alýan gazlary bölüp çykarýan serişdeler we ş.m.",     
      "Posladyjy, çüýrediji serişdeler: simap, kislota, aşgarlar, organiki perekisler we ş.m.",
      "Partlaýjy hem-de şolar bilen içi doldurylan serişdeler: däriler, ok-ýaraglar, kapsulalar, detonatorlar, yşyk-ýagtylyk tehnikalary we ş.m",
      "Üns beriň: Howa menzilinde: «bomba», «kislota»  ýa-da şulara meňzeş ýerliksiz sözler bilen oýun etmek bolmaz.  Ýolagçy uçuşdan galdyrylyp, soňky aýdyňlaşdyryş işlerini geçirmek we jenaýat jogapkärçiligine  çekmek  üçin  IIM-niň edaralaryna geçirilip bilner.",
      "EL GOŞGLARYNDA ÝANYŇ BILEN ALYP GITMEK GADAGAN EDILÝÄN ZATLAR:",
      "100 ml-den uly gaplardaky suwuk serişdeler we geller",
      "Islendik görnüşdäki ýaraglar we şolara meňzeş predmetler.",
      "Sanjylýan we kesiji predmetler:  dyky açyjylar, gaýçylar, iňňeler, paltalar, buz deşijiler, päkiler, pyçaklar, gylyçlar, hanjarlar we ş.m.",
      "Zarba urujy we owradyjy abzallar:  saýgyçlar,  dürli görnüşdäki dürreler, garpyşma urşunyň serişdeleri we ş.m.",
      "Iş abzallary: byçgylar,  montirowkalar, dreller, deşik deşijiler we ş.m.",
      "Uçuş wagtynda ýolagçynyň ýaragynyň wagtlaýyn saklamagy  resmileşdirmek we ekipažyň agzalaryna  tabşyrmak üçin hökmany suratda howa menziliniň uçuş howpsuzlygynyň işgärine gowşurylmalydyr . Ýaragy resmileşdirmek we howa gämisiniň içine salmak Siziň uçuşyňyza çenli 1,5 sagatdan gijä goýulman amala aşyrylýar.",
      "Ekipažyň agzalary we ýolagçylar tarapyndan howa gämisiniň içinde alyp gitmek gadagan edilýän howply serişdeleriň we predmetleriň jikme-jik sanawy IKAON-nyň howada howply ýükleri daşamagyň howpsuzlygy boýunça Tehniki gözükdirijisinde beýan edilýär.",
      "Eger-de siz el goşlaryňyz bilen bilelikde uçaryň içine salynmaýan zadyňyzy (zatlaryňyzy) hasaba alyş söýesinde tabşyrmasaňyz, olar eliňizden alnar."
    ]
  },
  { 
    title: "Jogapkärçilik",
    columns: 
    ["Barlag wagtynda öz ýanynda we goşlarynda howply maddalaryň, şeýle hem öndürmek, ýanyňda götermek we saklamak (ýaraglar, ok-däriler, partlaýjy enjamlar, neşe we awyly serişdeler, radioaktiw maddalar we ş.m.) jenaýat jogapkärçiligine eltýän zatlaryň tapylan ýagdaýynda ýolagçy uçuşa goýberilmeýär we şol zatlar (tapylan maddalar, serişdeler we olar barada ykrarnama) bilen bilelikde Türkmenistanyň kanunçylygyna laýyklykda ýüze çykan ýagdaýy seljermek üçin Aşgabat howa menzilindäki polisiýa bölümine geçirilýär."]
  }
]

const numbers = [
  {
    num: 1,
    title: "Terminala girýän adamlaryň deslapky barlagy",
  },
  {
    num: 2,
    title: "Hasaba alyş"
  },
  {
    num: 3,
    title: "Gümrük we serhet barlagy"
  },
  {
    num: 4,
    title: "Gümrük we migrasiýa gözegçiligi"
  },
  {
    num: 5,
    title: "Uçuşyň öň ýanyndaky barlag"
  }
]

const OutsideInfo = () => {
  return (
    <div className='w-full my-12'>
      <div className="flex flex-col mobileS:w-full lg:w-[70%] mx-auto justify-center items-center">
        <PreFlightsNumber props={numbers} />
       <div className="flex flex-col gap-6">
       <Accordion props={data}/>
       </div>
      </div>

    </div>
  )
}

export default OutsideInfo